import React from 'react';
import PropTypes from 'prop-types';

import Footer from 'src/app/components/Footer';
import styles from 'src/app/components/Layout/LayoutRightColumn.scss';


class LayoutRightColumn extends React.Component {
  state = {
    loaded: false
  }

  componentWillMount() {
    const { background } = this.props;
    const { src } = background;

    const image = new Image();
    const onLoad = () => {
      this.setState({ loaded: true });
      image.removeEventListener('load', onLoad);
    };
    image.addEventListener('load', onLoad);
    image.src = src;
  }

  render() {
    const { children, background } = this.props;
    const { loaded } = this.state;
    const { preSrc, src } = background;
    const imageUrl = loaded ? src : preSrc;

    return (
      <div styleName="right-column" style={ { backgroundImage: `url(${imageUrl})` } }>
        <div styleName="right-column__welcome welcome">
          {children}
        </div>
        <Footer customClass={ styles['right-column__footer'] } />
      </div>
    );
  }
}

LayoutRightColumn.propTypes = {
  children: PropTypes.node.isRequired,
  background: PropTypes.shape({
    preSrc: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired
  }).isRequired
};

export default LayoutRightColumn;
